import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text, TextAreaRichEditor } from '@reveni-io/reveni-ui'

import InsertVariables from '@/common/components/InsertVariables/InsertVariables'

import {
  errorTypes,
  shippingMethodDescriptionMaxLength,
  shippingMethodDescriptionSections,
  shippingMethodDescriptionVariables,
} from '../constants'
import useShippingMethodDescription from './hooks/useShippingMethodDescription/useShippingMethodDescription'
import { getDescriptionErrorMessage } from './helpers'
import * as Styles from './styles'

const ShippingMethodDescription = ({ description, onChange, errors }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { editorRef, editorHtml, descriptionLength, isTooLong, handleChangeEditor, handleAddVariable } =
    useShippingMethodDescription({ description, onChange })

  const errorMessage = getDescriptionErrorMessage(errors)
  const counterColor = isTooLong || errorMessage ? theme.colors.danger.default : theme.colors.text.subtle

  return (
    <Styles.Container id={errorTypes.descriptionEmpty}>
      <Text type="titleS">{t('Descripción')}</Text>
      <Styles.InputContainer id={errorTypes.descriptionTooLong}>
        <TextAreaRichEditor
          fullWidth
          textType="html"
          value={editorHtml}
          onChange={handleChangeEditor}
          label={t('Descripción del método de envío')}
          editorRef={editorRef}
          error={Boolean(errorMessage)}
        />
        <InsertVariables
          onAddVariable={handleAddVariable}
          availableVariables={shippingMethodDescriptionVariables}
          availableSections={shippingMethodDescriptionSections}
          tooltip={t(
            'Inserta variables en tu texto para añadir contenido dinámico como importes de envío, aranceles e impuestos.'
          )}
        />
        <Styles.Footer>
          {errorMessage && (
            <Text type="bodyXSRegular" color={theme.colors.danger.default}>
              {t(errorMessage)}
            </Text>
          )}
          <Styles.Counter>
            <Text type="bodyXSRegular" color={counterColor}>
              {`${descriptionLength}/${shippingMethodDescriptionMaxLength}`}
            </Text>
          </Styles.Counter>
        </Styles.Footer>
      </Styles.InputContainer>
    </Styles.Container>
  )
}

export default ShippingMethodDescription
